import React, { CSSProperties } from 'react';
import cx from 'clsx';
import { OrgVerifiedLogo } from '../OrgVerifiedLogo';
import { useTheme } from '@/hooks';
import { imgDefaultOfficialAccount, imgDefaultOfficialAccountDark } from '@/assets';
import style from './index.module.scss';
// import { UserCardPopupPropsPartial, UserCardPopup } from '@/components';

export enum OfficialAccountVerifyStatus {
  VERIFYING = 1,
  INACTIVE = 2,
  VERIFIED = 3,
  UNVERIFIED = 4,
  REJECT = 5,
}

export interface OfficialAccountAvatarProps {
  data?: OfficialAccount;
  size?: number;
  className?: string;
  onClick?(): void;
  logoVisible?: boolean;
  // userCardPopup?: UserCardPopupPropsPartial;
  logoOption?: {
    size?: number;
    customStyle?: CSSProperties;
  };
  logoTooltipVisible?: boolean;
}

export const OfficialAccountAvatar = ({
  data,
  size = 100,
  className,
  onClick,
  logoOption = { size: 28 },
  logoVisible = true,
  // userCardPopup,
  logoTooltipVisible = true,
}: OfficialAccountAvatarProps) => {
  const { isDark } = useTheme();
  const unverified = data?.verify_status !== OfficialAccountVerifyStatus.VERIFIED;
  const defaultAvatar = isDark ? imgDefaultOfficialAccountDark : imgDefaultOfficialAccount;

  const avatar = unverified
    ? defaultAvatar
    : data?.avatar_thumbnail_url || data?.avatar_url || defaultAvatar;

  const OfficialAvatar = (
    <div
      className={cx(style.officialAccountAvatar, className)}
      style={{ width: size, height: size }}
      onClick={onClick}>
      {logoVisible ? (
        <OrgVerifiedLogo
          className={style.logo}
          disableTooltip={!logoTooltipVisible}
          size={logoOption.size}
          style={{ right: 0, bottom: 0, ...logoOption.customStyle }}
          unverified={unverified}
        />
      ) : null}
      {!!avatar && (
        <img className={style.avatar} src={avatar} style={{ width: size, height: size }} alt="" />
      )}
    </div>
  );
  return OfficialAvatar;
};
